import React from "react";

const ErrorMessage = ({error}) => {

    if (!error){
        return null;
    }

    return  <div className="px-5">
                <span className="label label-xl label-light-danger w-100 rounded justify-content-start p-8 mb-10" style={{height: "inherit"}}>{error}</span>
            </div>           

}

export default ErrorMessage;